module.exports = __webpack_public_path__ + "files/9b2053a18baec3430ed5fc884936fcf5.png";